export default [ {
        value: '0',
        label: '未提交'
    }, {
        value: '1',
        label: '已提交'
    }, {
        value: '2',
        label: '提交失败'
    }, {
        value: '3',
        label: '超时'
    }, {
        value: '4',
        label: '成功'
    }, {
        value: '5',
        label: '失败'
    },{
        value: '6',
        label: '未知'
    },{
        value: '7',
        label: '待结算'
    },
];




// WEBPACK FOOTER //
// ./src/service/constant/SettlementType.js